"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.SignContractDocumentsButton = SignContractDocumentsButton;
exports.UploadSignedContractDocumentButton = UploadSignedContractDocumentButton;
const react_1 = __importStar(require("react"));
const typeGuards_1 = require("../../../Typings/typeGuards");
const SigningRowActions_1 = require("../../Signing/SigningRowActions");
const contractSigningSource_1 = require("./contractSigningSource");
/**
 * Akcja wiersza „PDF z podpisem” dla dokumentów umowy. Tylko umowy ENVI (nasze): umowa wykonawcy
 * nie jest podpisywana w ENVI, więc tu nic się nie pokazuje.
 */
function SignContractDocumentsButton({ dataObject, layout }) {
    const ourContract = (0, typeGuards_1.isOurContract)(dataObject) ? dataObject : null;
    const { id, alias } = dataObject;
    const ourId = ourContract?.ourId ?? "";
    const source = (0, react_1.useMemo)(() => (0, contractSigningSource_1.contractSigningSource)({ id, ourId, alias }), [id, ourId, alias]);
    if (!ourContract)
        return null;
    return react_1.default.createElement(SigningRowActions_1.SignPdfRowAction, { source: source, layout: layout });
}
/** Akcja wiersza „Wgraj podpisany” dla umów ENVI. */
function UploadSignedContractDocumentButton({ dataObject, layout }) {
    const ourContract = (0, typeGuards_1.isOurContract)(dataObject) ? dataObject : null;
    const { id, alias } = dataObject;
    const ourId = ourContract?.ourId ?? "";
    const source = (0, react_1.useMemo)(() => (0, contractSigningSource_1.contractSigningSource)({ id, ourId, alias }), [id, ourId, alias]);
    if (!ourContract)
        return null;
    return react_1.default.createElement(SigningRowActions_1.UploadSignedRowAction, { source: source, layout: layout });
}
